/** Transport timeout. `fetch` has none of its own; `linkSignals` enforces this. */
export const REQUEST_TIMEOUT_MS = 20_000;

/** GET-only. A mutation is typed so it cannot pass through `retryGet`. */
export const GET_RETRY_MAX_ATTEMPTS = 2;

/** Backoff base for a GET retry, not the poll interval. A 4s wait on a 500 resolve feels hung. */
export const GET_RETRY_BASE_MS = 400;

export const GET_RETRY_MAX_MS = 2_000;

export const GET_RETRY_JITTER = 0.15;

/** Manual "Refresh status" is rate-limited so a panicked tap storm cannot DDoS the poller. */
export const MANUAL_REFRESH_MIN_MS = 2_000;
